import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const authData = localStorage.getItem('access');

    if (authData) {
      const parsedAuthData = JSON.parse(authData);
      const token = parsedAuthData.token;
      const decodedToken: any = this.authService['decodeToken'](token);
      const isValidToken = this.authService['isTokenValid'](decodedToken);

      if (isValidToken) {
        return this.router.createUrlTree(['/dashboard/home']);
      }
    }

    return true;
  }
}